<template>
  <div class="body">
    <div class="one" v-if="tab == 0">
      <div class="o_top">
        <div>{{ getTimeOfDay() }}好，我一直在等你呢!</div>
        <img src="../../assets/img/i10.png" />
      </div>
      <!-- <div v-html="markedt(`# 幼儿成长档案\n## 【基本信息】\n- 幼儿姓名：小宇\n- 年龄：未提及\n- 观察日期：未提及\n- 观察教师：未提及\n- 观察区域：积木区\n- 选用材料：长条积木、圆柱积木、三角形积木（材质未知）\n- 合作同伴：阳阳，年龄未提及，在本次活动中与小宇共同搭建火箭，起初腼腆，后与小宇就积木搭建方式产生分歧并解决，负责递送特定形状积木。\n\n## 【观察记录】\n### 个体表现\n小宇进入积木区后，脸上带着热情、期待的神情，快速用长条积木围出方形底座（动作频率：围出底座过程中，放置长条积木动作约5次）。之后面对阳阳将圆柱积木叠在底座中央，皱着眉头，有些着急地大喊（语言复杂度：使用简单句，占比100%）。思索后拿起三角形积木提议。整个过程中，小宇主导搭建方向，神情认真。\n### 合作互动\n小宇主动邀请阳阳：“我们一起搭火箭吧！”阳阳微微点头，未出声回应，随后低头摆弄圆柱积木。阳阳突然将圆柱积木叠在底座中央，小宇着急大喊：“不对！火箭要尖尖的！”说着伸手要推倒圆柱，阳阳一脸坚定，紧握积木：“这是我的发射器！”两人僵持5秒。小宇露出思索、商量的神色提议：“这个放顶上当尖头，你的圆柱当燃料箱好吗？”阳阳神色缓和，松开手：“那…你要轻点放。”小宇在合作中表现出领导力，主动发起合作并主导搭建方向（SOC - LS3级）《指南》社会领域 - 交往合作 标准 。阳阳在合作中展现出坚持自己想法的特点，在小宇提议后能够协商解决问题（SOC - LS2级）《指南》社会领域 - 交往合作 标准 。\n\n## 【发展分析】\n| 领域 | 《指南》与双轨评估体系定位 | 皮亚杰认知和情感发展理论分析 | 量化数据 |\n|------------|----------------------------|------------------------------|--------------|\n| 动作发展 | 能用长条积木围出方形底座，体现手部精细动作能力（PHY - FM3级） → 《指南》健康领域 - 手部动作发展 | 根据皮亚杰认知发展理论，此阶段幼儿处于前运算阶段，通过摆弄积木等动作来认识物体形状、功能等，小宇围出底座的动作是对空间和物体操作的初步探索 | 放置长条积木动作约5次 |\n| 语言表达 | 以简单句进行交流，如“不对！火箭要尖尖的！”（语言复杂度：简单句占比100%） → 《指南》语言领域 - 基本的语言交流 | 前运算阶段幼儿语言发展以自我中心言语为主，小宇在表达自己观点时较为直接，未过多考虑阳阳感受，随着交流深入，逐渐尝试协商性语言 | 简单句占比100% |\n| 思维维度 | 面对阳阳不同搭建想法，能思索后提出解决方案，如用三角形积木当尖头，圆柱当燃料箱，体现思维灵活性（THI - FL2级） → 《指南》科学领域 - 思维能力发展 | 处于前运算阶段，幼儿开始运用符号和表象进行思维，小宇能在原有搭建思路基础上，结合阳阳想法，调整搭建方案，体现思维的初步灵活性 | - |\n| 社交维度 | 主动邀请阳阳合作搭建火箭，在分歧时能协商解决问题，展现领导力和协商能力（SOC - LS3级、SOC - LS2级） → 《指南》社会领域 - 交往合作 | 幼儿在合作中逐渐理解他人观点，小宇从着急否定阳阳到协商解决，阳阳从坚持自我到接受协商，体现情感发展中对他人情感和想法的认知与适应 | 僵持5秒 |\n\n## 【指导建议】\n### 家庭建议\n1. 目标：提升合作协商能力与思维灵活性。\n2. 具体步骤：开展“创意建筑”游戏，准备各类积木（木质、塑料积木均可，数量根据实际情况）。家长与孩子一起搭建建筑，过程中家长提出不同搭建想法，与孩子产生分歧，引导孩子协商解决，如尝试不同搭建方案。\n3. 思维共享话题：讨论如果积木不够用，还可以用什么物品代替来完成搭建。\n4. 能力迁移可能性：合作协商能力可迁移至与小伙伴玩游戏制定规则场景，思维灵活性可迁移至解决生活中遇到的小困难，如玩具损坏如何修理。\n\n### 幼儿园建议\n1. 目标：进一步强化合作意识与语言表达能力。\n2. 具体步骤：组织小组搭建活动，提供丰富多样的搭建材料。教师观察幼儿合作情况，适时引导幼儿清晰表达想法，鼓励幼儿倾听他人意见。例如，在小组搭建前，引导幼儿讨论搭建主题和分工。\n3. 思维共享话题：讨论搭建作品完成后可以进行哪些相关游戏，如搭建城堡后玩角色扮演游戏。\n4. 能力迁移可能性：合作意识可迁移至班级集体活动，语言表达能力可迁移至故事讲述活动。\n\n### 个性化支持建议\n1. 目标：针对小宇，增强倾听他人意见能力；针对阳阳，提升主动表达能力。\n2. 具体步骤：对于小宇，教师在日常活动中提醒他多倾听同伴想法，给予阳阳表达机会；对于阳阳，教师鼓励他主动表达自己的想法，如在小组讨论时，引导阳阳先发言。\n3. 思维共享话题：对于小宇，讨论如果同伴想法更好，应该怎么做；对于阳阳，讨论如何更清晰地表达自己的创意。\n4. 能力迁移可能性：小宇倾听能力可迁移至课堂听讲，阳阳主动表达能力可迁移至课堂回答问题。\n\n### 能力迁移记录表\n| 能力 | 活动实例 |\n| ---- | ---- |\n| 合作协商能力 | 在“搭建动物园”活动中，小宇与同伴协商动物场馆位置 |\n| 思维灵活性 | 在“创意手工”活动中，阳阳用不同材料替代原有材料完成作品 |\n| 倾听能力（小宇） | 在故事分享课上，小宇认真倾听同伴分享 |\n| 主动表达能力（阳阳） | 在“我喜欢的玩具”分享活动中，阳阳主动上台介绍自己玩具 |\n\n## 【多媒体链接】\n此处可添加活动照片、视频片段二维码，因实际未提供相关多媒体，暂未列出具体内容。\n\n## 【家庭反馈区】\n家长可在此处填写亲子活动记录和观察反馈，如孩子在家庭“创意建筑”游戏中的表现、与在幼儿园表现的差异等。 `)"></div> -->
      <div class="o_bottom">
        <div class="file">
          <div class="f_item" v-for="(item, index) in fileList" :key="index" @click="btn_delFile(item, index)">
            <img class="fi_icon" :src="settingFileIcon(item.resourceType, item.path)" />
            <div class="fi_text line1_">{{ item.name || item.path }}</div>
            <img class="fi_del" src="../../assets/img/i52.png" />
          </div>
        </div>
        <textarea placeholder="给Deepseek发信息..." v-model="inputContent" @keyup="carriageReturn"></textarea>
        <div class="ob_bottom">
          <div class="obb_left">R1深度思考</div>
          <div class="obb_right">
            <el-upload :headers="myHeaders" :http-request="handleUploadForm" :on-change="imgSaveToUrl"
              :show-file-list="false" action class="upload-demo" multiple accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx">
              <img class="bbr_1" src="../../assets/img/i7.png" />
            </el-upload>
            <el-upload :headers="myHeaders" :http-request="handleUploadImgForm" :on-change="imgSaveToUrl"
              :show-file-list="false" action class="upload-demo" multiple accept="image/*">
              <img class="bbr_1" src="../../assets/img/i8.png" />
            </el-upload>
            <img class="bbr_2" src="../../assets/img/i9.png" @click="btn_send" />
          </div>
        </div>
      </div>
    </div>
    <div class="chat" v-if="tab == 1">
      <div class="ch_bottom" ref="scrollDiv">
        <div class="chb_item" v-for="(item, index) in list" :key="index">
          <div class="time">{{ item.time }}</div>
          <div class="chb_left" v-if="!item.isMine">
            <!-- <img class="hbl_left" src="../../assets/img/aitx.png" /> -->
            <div class="hbl_right">
              <div class="blr_top">
                <div class="loading-container" v-if="isLoading && index == list.length - 1">
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                </div>
                <div class="ds" v-if="item.reasoning_content" @click="item.show = !item.show">
                  <img class="ds_icon" src="../../assets/img/i47.png" />
                  <div class="ds_text">Deepseek-R1满血版 思考完成</div>
                  <img class="ds_jt"
                    :src="item.show ? require('../../assets/img/i48.png') : require('../../assets/img/i49.png')" />
                </div>
                <div style="color: #757575 !important;border-left: 2px solid #e5e5e5;padding-left: 10px;"
                  v-html="markedt(item.reasoning_content)" v-if="item.reasoning_content && item.show"></div>
                <div v-html="markedt(preprocessLaTeX(item.text))" v-if="item.text"></div>
              </div>
              <div class="blr_bottom" v-if="index > 0 && index == list.length - 1 && !stop">
                <div class="lrb_btn" @click="btn_reanswer">
                  <img src="../../assets/img/i24.png" />
                  再来一次
                </div>
                <!-- <div class="lrb_btn">
                  <img src="../../assets/img/i23.png" />
                  下载
                </div> -->
                <div class="lrb_btn" @click="handleClipboard(item.text, $event)">
                  <img src="../../assets/img/i22.png" />
                  复制
                </div>
              </div>
            </div>
          </div>
          <div class="chb_right" v-if="item.isMine">
            <div class="file" style="justify-content: flex-end;">
              <div class="f_item" v-for="(itemA, indexA) in item.fileList" :key="indexA">
                <img class="fi_icon" :src="settingFileIcon(itemA.resourceType, itemA.path)" />
                <div class="fi_text line1_">{{ itemA.name || itemA.path }}</div>
              </div>
            </div>
            <div class="hbr_text" v-html="item.text"></div>
            <!-- <img class="hbr_tx" :src="webImg + userInfo.avatar" /> -->
          </div>
        </div>
      </div>
      <div class="o_bottom1">
        <img class="ob_down" src="../../assets/img/down.png" v-if="!autoScroll" @click="btn_scrollBottom" />
        <div class="file">
          <div class="f_item" v-for="(item, index) in fileList" :key="index" @click="btn_delFile(item, index)">
            <img class="fi_icon" :src="settingFileIcon(item.resourceType, item.path)" />
            <div class="fi_text line1_">{{ item.name || item.path }}</div>
            <img class="fi_del" src="../../assets/img/i52.png" />
          </div>
        </div>
        <textarea placeholder="给Deepseek发信息..." v-model="inputContent" @keyup="carriageReturn"></textarea>
        <div class="ob_bottom1">
          <div class="obb_left">R1深度思考</div>
          <div class="obb_right">
            <el-upload :headers="myHeaders" :http-request="handleUploadForm" :on-change="imgSaveToUrl"
              :show-file-list="false" action class="upload-demo" multiple accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx">
              <img class="bbr_1" src="../../assets/img/i7.png" />
            </el-upload>
            <el-upload :headers="myHeaders" :http-request="handleUploadImgForm" :on-change="imgSaveToUrl"
              :show-file-list="false" action class="upload-demo" multiple accept="image/*">
              <img class="bbr_1" src="../../assets/img/i8.png" />
            </el-upload>
            <img class="bbr_2" src="../../assets/img/i9.png" @click="btn_send" />
          </div>
        </div>
      </div>
    </div>
    <div class="list" v-if="tab == 2">
      <!--  :infinite-scroll-distance="50"
        :infinite-scroll-immediate="false" v-infinite-scroll="load" -->
      <div class="item">
        <div class="i_top">本月</div>
        <el-empty description="暂无数据" v-if="monthList.length == 0"></el-empty>
        <div class="i_bottom" v-for="(item, index) in monthList" :key="index">
          <div class="ib_left line1_" @click="btn_historyItem(item, index)">{{ item.prompt }}</div>
          <div class="ib_right">{{ item.lastChatTimeStr }}</div>
          <div class="ib_btn">
            <img src="../../assets/img/i60.png" @click.stop="btn_item(item, index, 1)" />
            <img src="../../assets/img/i61.png" @click.stop="btn_item(item, index, 2)" />
          </div>
        </div>
      </div>
      <div class="item">
        <div class="i_top">本年</div>
        <el-empty description="暂无数据" v-if="yearList.length == 0"></el-empty>
        <div class="i_bottom" v-for="(item, index) in yearList" :key="index" @click="btn_historyItem(item, index)">
          <div class="ib_left line1_">{{ item.prompt }}</div>
          <div class="ib_right">{{ item.lastChatTimeStr }}</div>
          <div class="ib_btn">
            <img src="../../assets/img/i60.png" @click.stop="btn_item(item, index, 1)" />
            <img src="../../assets/img/i61.png" @click.stop="btn_item(item, index, 2)" />
          </div>
        </div>
      </div>
    </div>
    <div class="menu">
      <img class="m_item1" src="../../assets/img/i2.png" @click="tab = 0" />
      <div class="m_item2" v-for="(item, index) in menuList" :key="index" @mouseover="mouseover($event, index)"
        @mouseout="mouseout($event, index)" @click="btn_menu(item, index)">
        <img :src="item.icon" />
        <div v-show="menuIndex == index" v-if="index == 0 || index == 1 || index == 3 || index == 4">{{ item.name }}
        </div>
        <img class="kf" src="../../assets/img/kefu.jpg" v-show="menuIndex == index" v-if="index == 2" />
      </div>
      <div class="m_item3" @mouseover="mouseover($event, 5)" @mouseout="mouseout($event, 5)">
        <img src="../../assets/img/i6.png" />
        <img class="ewm" src="../../assets/img/qrcode.png" v-show="menuIndex == 5" />
      </div>
      <!-- <img class="m_item4" :src="webImg + userInfo.avatar" @click="$router.push('/my')" /> -->
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <el-input v-model="currentItem.prompt" placeholder="请输入"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="btn_submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible1" width="30%">
      <span>是否确定删除该条记录？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="btn_del">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

// import '../../../node_modules/mathjax/es5/tex-mml-chtml'
import { fetchEventSource } from '@microsoft/fetch-event-source';
import axios from 'axios'
import '@/assets/katex/dist/katex.min.css';
import MarkdownIt from 'markdown-it'
import { helperInfo, promptInfo, ossToken, fileResourceList, addScore, helperUploadFileToKimi, universalCreateSession, universalHelperSessionList, helperMsgDetailList, universalHelperSessionRename, universalHelperSessionDelete } from '@/apis/index'
import Clipboard from 'clipboard'
// import markdownItKatex from 'markdown-it-katex';
import markdownItKatex from '@iktakahiro/markdown-it-katex';

var txtMsg = "";
const markdownRender = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,
  breaks: true
});
markdownRender.use(markdownItKatex);
export default {
  data() {
    return {
      tab: 0,
      flag2: false,
      list: [
        { text: "您好，我是你的专属助理，有什么我能帮助你的吗？", isMine: false, time: this.getDateTime2(new Date().getTime()) },
      ],
      flag: false,
      userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
      sourceType: '',
      info: {},
      templateList: [],
      prompts: '',
      stop: false,
      isLoading: false,
      controller: null,
      inputContent: '',
      eventSource: null,
      myHeaders: { "X-Token": ossToken() },
      hover: false,
      sessionId: '', //会话ID
      reAnswerFlag: false,
      fileList: [],
      menuIndex: null,
      menuList: [{ name: '新建会话', icon: require('../../assets/img/i3.png') }, { name: '历史记录', icon: require('../../assets/img/i4.png') }, { name: '联系客服', icon: require('../../assets/img/i5.png') }, { name: '课堂转录', icon: require('../../assets/img/i56.png') }, { name: '讲座会议转录', icon: require('../../assets/img/i57.png') }],
      dsFlag: false,
      pageNum: 1,
      total: 0,
      recordList: [],
      monthList: [],
      yearList: [],
      dialogVisible: false,
      currentItem: {},
      dialogVisible1: false,
      gs: '',
      autoScroll: true
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   if (this.$mathJax.isMathjaxConfig) {
    //     // 判断是否初始配置，若⽆则配置。
    //     this.$mathJax.initMathjaxConfig()
    //     console.log(this.$mathJax, 'mathJax');
    //   }
    //   this.$mathJax.TypeSet()
    // })
    this.getUniversalCreateSession()
    // this.handleScrollBottom()
  },
  updated() {
    // this.$nextTick(() => {
    //   if (this.$mathJax.isMathjaxConfig) {
    //     // 判断是否初始配置，若⽆则配置。
    //     this.$mathJax.initMathjaxConfig()
    //     console.log(this.$mathJax, 'mathJax');
    //   }
    //   this.$mathJax.TypeSet()
    // })
  },
  beforeDestroy() {
    const scrollElem = this.$refs.scrollDiv;
    scrollElem.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    btn_del() {
      universalHelperSessionDelete(this.currentItem.id).then(res => {
        console.log(res, 'universalHelperSessionDelete');
        this.$message({
          message: '删除成功',
          type: 'success'
        });
        this.dialogVisible1 = false
        this.getUniversalHelperSessionList()
      })
    },
    btn_submit() {
      universalHelperSessionRename({
        customName: this.currentItem.prompt,
        id: this.currentItem.id
      }).then(res => {
        console.log(res, 'universalHelperSessionRename');
        this.$message({
          message: '修改成功',
          type: 'success'
        });
        this.dialogVisible = false
        this.getUniversalHelperSessionList()
      })
    },
    btn_item(item, index, type) {
      this.currentItem = JSON.parse(JSON.stringify(item))
      if (type == 1) {
        this.dialogVisible = true
      } else {
        this.dialogVisible1 = true
      }
    },
    btn_historyItem(item, index) {
      this.tab = 1
      this.sessionId = item.id
      this.getHelperMsgDetailList();
    },
    getHelperMsgDetailList() {
      helperMsgDetailList(this.sessionId).then((res) => {
        console.log(res, 'helperMsgDetailList');
        // 清空列表以防止重复赋值
        this.list = [];
        // 处理第一条数据
        if (res.data.techHelperMsgs.length > 0) {
          const firstItem = res.data.techHelperSession;
          this.list.push({
            text: firstItem.prompt,
            isMine: true,
            time: firstItem.createTime
          });
        }

        // 处理后续数据
        res.data.techHelperMsgs.forEach((item, index) => {
          if (index > 0) { // 从第二条数据开始处理
            item.text = item.content;
            item.isMine = item.senderType == 1;
            this.list.push(item);
          }
        });

        // 更新历史消息和最后一条消息ID
        this.historyMsg = res.data.techHelperSession.prompt;
        this.msgId = res.data.techHelperMsgs[res.data.techHelperMsgs.length - 1]?.id; // 使用可选链避免错误
      });
    },
    load() {
      // this.throttle(() => {
      //   if (this.pageNum > this.recordList.length) {
      //     this.pageNum++
      //     this.getUniversalHelperSessionList()
      //   }
      // })
    },
    getUniversalHelperSessionList() {
      universalHelperSessionList(this.pageNum).then(res => {
        console.log(res, 'universalHelperSessionList');
        // if (this.pageNum == 1) {
        //   this.recordList = []
        // }
        // this.recordList = [...this.recordList, ...res.data.list]
        // this.pageNum = res.data.total

        this.monthList = res.data.monthList
        this.yearList = res.data.yearList
      })
    },
    btn_menu(item, index) {
      if (index == 0) {
        this.$router.go(0)
      }
      if (index == 1) {
        this.tab = 2
        this.pageNum = 1
        this.getUniversalHelperSessionList()
      }
      if (index == 3 || index == 4) {
        return this.$message({
            message: '功能升级中，敬请期待',
            type: 'warning'
          });
        var type = index == 3 ? 1 : 2
        // this.$router.push({path: '/simultaneousInterpretation', query: {type: index == 3? 1 : 2}})
        if (process.env.NODE_ENV === 'development') { //development   production
          //开发环境
          window.open(`http://localhost:8081/#/simultaneousInterpretation?type=${type}`, '_blank')
        } else {
          // 获取当前页面的完整 URL
          const fullUrl = window.location.href;
          // 使用 URL 对象解析 URL
          const urll = new URL(fullUrl);
          // 获取域名部分
          var url = `${urll.protocol}//${urll.host}`;
          if (urll.host.includes('test')) {
            // 如果是部署在测试服下
            url = `${urll.protocol}//${urll.host}/pc`;
          }
          window.open(`${url}/#/simultaneousInterpretation?type=${type}`, '_blank')
        }
      }
    },
    btn_delFile(item, index) {
      this.fileList.splice(index, 1);
      this.$forceUpdate();
    },
    mouseover(e, index) {
      this.menuIndex = index
    },
    mouseout(e, index) {
      this.menuIndex = null
    },
    getTimeOfDay() {
      const now = new Date(); // 获取当前时间
      const hours = now.getHours(); // 获取当前小时

      if (hours >= 6 && hours < 12) {
        return "上午"; // 6:00 - 11:59
      } else if (hours === 12) {
        return "中午"; // 12:00
      } else if (hours > 12 && hours < 18) {
        return "下午"; // 13:00 - 17:59
      } else {
        return "晚上"; // 18:00 - 23:59
      }
    },
    btn_reanswer() {
      this.reAnswerFlag = true
      this.btn_send()
    },
    getUniversalCreateSession() {
      universalCreateSession().then(res => {
        console.log(res, 'universalCreateSession');
        this.sessionId = res.data
      })
    },
    handleClipboard(text, event) {
      console.log(event);
      const clipboard = new Clipboard(event.target, {
        text: () => text
      })
      clipboard.on('success', () => {
        this.clipboardSuccess()
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.clipboardError()
        clipboard.destroy()
      })
      clipboard.onClick(event)
    },
    clipboardSuccess() {
      this.$message.success('复制成功')
    },
    clipboardError() {
      this.$message.error('复制失败')
    },

    carriageReturn(event) {
      let e = window.event || arguments[0];
      if (!e.ctrlKey && e.keyCode == 13) {
        e.returnValue = false;
        this.btn_send();
        return false;
      }
    },
    copyContent(text) {
      navigator.clipboard.writeText(text)
        .then(() => {
          this.$message.success('复制成功')
        }).catch(err => {
          console.error('无法复制文本: ', err);
        });
    },
    btn_fileResItem(item, index) {
      item.select = item.select == 0 ? 1 : 0
    },
    pathType(e) {
      const lastIndex = e.lastIndexOf('/');
      const result = e.substring(lastIndex + 1);
      const fileExtension = e.split('.').pop();
      return fileExtension
    },
    handleUploadImgForm(param) {
      console.log(param, 'imgup');
      const formData = new FormData();
      formData.append("multipart", param.file);
      let loading = this.$loading({
        lock: true,
        text: "上传中，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // 获取上传token
      ossToken(param.file.name).then(res => {
        let ossRes = JSON.parse(res.data);
        console.log(ossRes, 'getOssToken')
        const ossData = new FormData();
        Object.keys(ossRes).forEach((key) => {
          ossData.append(key, ossRes[key]);
        });
        console.log(param.file, 'param.file')
        ossData.append("file", param.file);
        var url = ossRes.host;
        axios({
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          method: 'post',
          url: url,
          data: ossData
        }).then(async (res2) => {
          console.log(res2, 'getOssToken axios')
          this.fileList.push({
            path: res2.data.url,
            resourceType: 2,
            select: 1,
            name: param.file.name
          })
          loading.close();
          console.log(this.fileList, 'fileList');
        })
      })
    },
    // 选取图片后自动回调，里面可以获取到文件
    imgSaveToUrl(event) {
      console.log(event, 'eventOnchange');
    },
    handleDragOver(event) {
      // 可以添加一些视觉反馈
    },
    handleDrop(event) {
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        this.uploadFiles(files);
      }
    },
    uploadFiles(param) {
      console.log(param, 'imgup');
      const formData = new FormData();
      formData.append("multipart", param[0]);
      let loading = this.$loading({
        lock: true,
        text: "上传中，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // 获取上传token
      ossToken(param[0].name).then(res => {
        let ossRes = JSON.parse(res.data);
        console.log(ossRes, 'getOssToken')
        const ossData = new FormData();
        Object.keys(ossRes).forEach((key) => {
          ossData.append(key, ossRes[key]);
        });
        ossData.append("file", param[0]);
        var url = ossRes.host;
        axios({
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          method: 'post',
          url: url,
          data: ossData
        }).then(async (res2) => {
          console.log(res2, 'getOssToken axios')
          this.fileList.push({
            path: res2.data.url,
            resourceType: 3,
            select: 1,
            name: param.file.name
          })
          loading.close();
          console.log(this.fileList, 'fileList');
        })
      })
    },
    // 上传
    handleUploadForm(param) {
      const formData = new FormData();
      formData.append("multipart", param.file);
      let loading = this.$loading({
        lock: true,
        text: "上传中，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // 获取上传token
      ossToken(param.file.name).then(res => {
        let ossRes = JSON.parse(res.data);
        console.log(ossRes, 'getOssToken')
        const ossData = new FormData();
        Object.keys(ossRes).forEach((key) => {
          ossData.append(key, ossRes[key]);
        });
        ossData.append("file", param.file);
        var url = ossRes.host;
        axios({
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          method: 'post',
          url: url,
          data: ossData
        }).then(async (res2) => {
          console.log(res2, 'getOssToken axios')
          this.fileList.push({
            path: res2.data.url,
            resourceType: 3,
            select: 1,
            name: param.file.name
          })
          loading.close();
        })
      })
    },
    markedt(markdown) {
      // markdown = markdown.replace(/\$(.*?)\$/g, (match, p1) => {
      //   // 在匹配的内容中替换乘号和 \frac
      //   const replaced = p1
      //     .replace(/×/g, '\\times') // 替换乘号
      //   // .replace(/\frac/g, '\\\\frac'); // 替换 \frac
      //   return `$${replaced}$`; // 返回替换后的内容
      // });
      if (markdown) {
        return markdownRender.render(markdown);
      }
      return '';
    },
    arrayToRichText(array) {
      let html = '<div>';
      for (let i = 0; i < array.length; i++) {
        if (!array[i].attrName) {
          html += `<div>${array[i].title + ':  ' + (array[i].defaultVal || '')}</div>`;
        } else if (array[i].attrName) {
          html += `<div>${array[i].attrName + ':  ' + (array[i].selectName || '')}</div>`;
        }
      }
      html += '</div>';
      return html;
    },
    textReplace() {
      // 创建一个新的 Map
      const dataMap = new Map();
      // 使用 forEach 方法填充 Map
      this.templateList.forEach(obj => {
        if (obj.defaultVal) {
          dataMap.set(obj.title, obj.defaultVal);
        }
      });
      console.log(dataMap, 'dataMap');
      // 替换字符串中的占位符
      this.prompts = this.prompts.replace(/{(.*?)}/g, (match, key) => {
        console.log(dataMap.get(key) || match, 'ssssss');
        return dataMap.get(key) || ''; // 如果找不到对应的值，则保留原始占位符
      });
      console.log(this.prompts, 'prompts');
    },

    btn_send() {
      this.tab = 1
      setTimeout(() => {
        const scrollElem = this.$refs.scrollDiv;
        scrollElem.addEventListener('scroll', this.handleScroll);
      }, 500);
      // this.flag2 = true
      // 只有当eventSource不存在时才创建新的EventSource连接
      if (!this.stop) {
        this.controller = new AbortController();
        const { signal } = this.controller;
        var msg = ''
        if (this.inputContent.trim() == '' && !this.reAnswerFlag) {
          return this.$message.warning('请先输入内容')
        }
        if (!this.inputContent) {
          this.textReplace()
          msg = this.arrayToRichText(this.templateList)
        } else {
          msg = this.inputContent
        }
        console.log(msg, 'msg');
        var flist = []
        if (this.fileList.length > 0) {
          // flist = this.fileList.map(e => e.taskId)
          flist = this.fileList.map(e => e.path)
        }
        // const fileText = this.fileList.length > 0 ? `[等${this.fileList.length}条资源文件]` : '';
        // const result = `${msg} ${fileText}`;
        if (!this.reAnswerFlag) {
          this.list.push({ text: msg, isMine: true, fileList: [...this.fileList], time: this.getDateTime2(new Date().getTime()) });
        }
        this.list.push({ text: "", show: true, isMine: false, time: this.getDateTime2(new Date().getTime()), reasoning_content: '', });
        this.handleScrollBottom()
        var this_ = this
        this.stop = true
        this.isLoading = true
        // 创建新的EventSource连接
        var url = process.env.VUE_APP_BASE_API + `universalHelper/completions`
        this.eventSource = fetchEventSource(url, {
          method: 'POST',
          headers: {
            "Content-Type": 'application/json',
            "Accept": 'text/event-stream',
            "token": localStorage.getItem('token')
          },
          body: JSON.stringify({
            sessionId: this.sessionId,
            messages: this.inputContent,
            prompts: !this.inputContent ? this.prompts : '',
            filePathList: flist,
            reAnswerFlag: this.reAnswerFlag
          }),
          signal: signal,
          openWhenHidden: true,
          onmessage(event) {
            // console.info(event.data);

            if (event.data && this_.isLoading) {
              this_.isLoading = false
            }
            this_.reAnswerFlag = false
            let dataJ = JSON.parse(event.data)
            if (dataJ.reasoning_content) {
              this_.list[this_.list.length - 1].reasoning_content += dataJ.reasoning_content;
              // console.log(this_.list[this_.list.length - 1].reasoning_content, 'sss');
            }
            this_.list[this_.list.length - 1].text += dataJ.content;
            this_.$forceUpdate()
            this_.handleScrollBottom()
          },
          onclose(ee) {
            // 关闭流
            this_.close()
            this_.autoScroll = true
          },
          onerror(error) {
            console.info(error);
            //返回流报错
          }
        });
        console.log(this.eventSource, 'eventSource');
        this.inputContent = ''
        this.fileList = []
      }
    },
    close() {
      this.controller.abort();
      this.controller = null
      this.stop = false
      this.isLoading = false
      // this.eventSource = null; // 重置eventSource变量，允许重建连接
      // this.eventSource.close(); // 关闭出错的连接
    },
    btn_scrollBottom() {
      let scrollElem = this.$refs.scrollDiv;
      scrollElem.scrollTo({ top: scrollElem.scrollHeight, behavior: 'smooth' });
    },
    handleScroll() {
      const scrollElem = this.$refs.scrollDiv;
      // 判断是否接近底部，阈值可以调整
      const threshold = 50;
      const isBottom = scrollElem.scrollHeight - scrollElem.scrollTop - scrollElem.clientHeight < threshold;
      console.log(isBottom, 'isBottom');

      this.autoScroll = isBottom;
    },
    // 滚动到底部
    handleScrollBottom() {
      if (!this.autoScroll) return; // 如果用户手动滚动了，不自动滚动
      this.$nextTick(() => {
        const scrollElem = this.$refs.scrollDiv;
        scrollElem.scrollTo({ top: scrollElem.scrollHeight, behavior: 'smooth' });
      });
    },
  }
}
</script>

<style lang="scss" scoped>
// @import '../../assets/katex/dist/katex.min.css';
::v-deep {

  ol,
  ul {
    padding-left: 2em;

  }

  li {
    list-style: decimal !important;
  }

  code {
    /*元素内的空白保留，并允许换行*/
    white-space: pre-wrap !important;
    /*是否允许在单词内断句*/
    word-wrap: break-word !important;
    // font-family: PingFang;
  }

  .katex-html {
    // display: none !important;
  }

  annotation {
    display: none !important;
  }

  table {
    border-collapse: collapse;
    /* 确保表格的边框线会合并为单一的线条 */
    border: 1px solid black;
    /* 设置表格的边框 */
  }

  td,
  th {
    border: 1px solid black;
    /* 设置单元格的边框 */
  }

  h1 {
    font-size: 16px;
    font-weight: bold;
  }

  h2 {
    font-size: 16px;
    font-weight: bold;
  }

  h3 {
    font-size: 16px;
    font-weight: bold;
  }

  p {
    font-size: 16px;
  }

  li {
    font-size: 16px;
  }
}

.file {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .f_item:nth-child(3n) {
    margin-right: 0 !important;
  }

  .f_item {
    width: 262px;
    height: 55px;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 8px;
    display: flex;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.03);
    margin-right: 15px;
    margin-bottom: 15px;

    .fi_icon {
      width: 30px;
      height: 30px;
    }

    .fi_text {
      color: #000000;
      font-size: 14px;
      font-weight: 500;
      flex: 1;
      margin: 0 10px;
    }

    .fi_del {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }
}

.body {
  width: 1200px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .menu {
    width: 60px;
    height: 600px;
    background: #FFFFFF;
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #E9EBF2;
    position: fixed;
    left: 20px;
    top: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding: 10px 0;

    .m_item1 {
      width: 40px;
      height: 40px;
      margin-bottom: 40px;
      cursor: pointer;
    }

    .m_item2 {
      width: 28px;
      height: 28px;
      margin-bottom: 40px;
      cursor: pointer;
      position: relative;

      .kf {
        width: 150px;
        height: auto;
        position: absolute;
        right: -170px;
        top: -40px;

      }

      img {
        width: 100%;
        height: 100%;
      }

      div {
        position: absolute;
        left: 60px;
        top: 0px;
        width: 100px;
        text-align: center;
        background: #000000;
        border-radius: 8px 8px 8px 8px;
        padding: 10px;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
      }
    }

    .m_item3 {

      margin-top: 125px;
      cursor: pointer;
      position: relative;

      .ewm {
        width: 220px;
        height: auto;
        position: absolute;
        right: -240px;
        bottom: 0px;
      }

      img {
        width: 32px;
        height: 32px;
      }
    }

    .m_item4 {
      width: 36px;
      height: 36px;
      border-radius: 6px;
      border: 1px solid #F1F1F1;
      margin-top: 30px;
      cursor: pointer;

    }
  }

  .list::-webkit-scrollbar {
    display: none;
  }

  .list {
    width: 900px;
    height: 0;
    flex: 1;
    box-sizing: border-box;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: scroll;

    .item {
      width: 100%;
      margin-bottom: 20px;

      .i_top {
        font-weight: 400;
        font-size: 24px;
        color: #212121;
      }

      .i_bottom {
        width: 100%;
        height: 48px;
        background: #FFFFFF;
        border-radius: 12px 12px 12px 12px;
        border: 1px solid #E9EBF2;
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 30px;
        cursor: pointer;

        .ib_left {
          flex: 1;
          height: 100%;
          margin-right: 30px;
          font-weight: 500;
          font-size: 16px;
          color: #333333;
          line-height: 48px;
          // display: flex;
          // align-items: center;
        }

        .ib_right {
          font-weight: 500;
          font-size: 16px;
          color: #666666;
        }

        .ib_btn {
          display: flex;
          align-items: center;

          img {
            width: 24px;
            height: 24px;
            // margin: 0 15px;
            margin-left: 15px;
          }
        }
      }
    }
  }

  .chat {
    width: 900px;
    height: 0;
    flex: 1;
    box-sizing: border-box;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .ch_bottom::-webkit-scrollbar {
      display: none;
    }

    .ch_bottom {
      width: 100%;
      height: 0;
      flex: 1;
      overflow-y: scroll;
      margin-bottom: 15px;
      box-sizing: border-box;
      padding-bottom: 50px;

      .chb_item {
        width: 100%;
        margin-top: 20px;
        position: relative;

        // padding-top: 60px;
        .time {
          position: absolute;
          top: 0;
          width: 100%;
          text-align: center;
          font-weight: 500;
          font-size: 14px;
          color: #999999;
        }

        .chb_left {
          width: 100%;
          display: flex;
          align-items: flex-start;
          padding-top: 40px;

          .hbl_left {
            width: 44px;
            height: 44px;
          }

          .hbl_right {
            // flex: 1;
            // margin-left: 20px;
            width: fit-content;
            // max-width: 500px;
            background: #FAFAFA;
            border-radius: 10px 10px 10px 10px;
            box-sizing: border-box;
            padding: 10px;

            .blr_top {
              font-weight: 500;
              font-size: 16px;
              color: #333333;
              line-height: 32px;

              .ds {
                width: 284px;
                height: 30px;
                background: #E5EAFF;
                border-radius: 8px 8px 8px 8px;
                box-sizing: border-box;
                padding: 0 14px;
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                cursor: pointer;

                .ds_icon {
                  width: 19px;
                  height: 14px;
                }

                .ds_text {
                  font-weight: 500;
                  font-size: 14px;
                  color: #4D6BFE;
                  margin: 0 8px;
                  user-select: none;
                }

                .ds_jt {
                  width: 9px;
                  height: 7px;
                }
              }

              .loading-container {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
                // margin-top: 30rpx;
                box-sizing: border-box;
                padding: 10px;
                border-radius: 20px;
                margin-left: 16px;
                user-select: auto;
              }

              .dot {
                width: 10px;
                height: 10px;
                background-color: #333;
                border-radius: 50%;
                margin: 0 5px;
                animation: blink 1.4s infinite both;
                opacity: 0;
              }

              .dot:nth-child(1) {
                animation-delay: 0.2s;
              }

              .dot:nth-child(2) {
                animation-delay: 0.4s;
              }

              .dot:nth-child(3) {
                animation-delay: 0.6s;
              }

              @keyframes blink {
                0% {
                  opacity: 0;
                }

                50% {
                  opacity: 1;
                }

                100% {
                  opacity: 0;
                }
              }
            }

            .blr_bottom {
              width: 100%;
              display: flex;
              align-items: center;
              border-top: 1px solid#ececec;
              margin-top: 10px;
              padding-top: 10px;

              .lrb_btn {
                font-weight: 500;
                font-size: 14px;
                color: #333333;
                margin-right: 30px;
                display: flex;
                align-items: center;
                cursor: pointer;

                img {
                  width: 14px;
                  height: 14px;
                  margin-right: 5px;
                }
              }
            }
          }
        }

        .chb_right {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          padding-top: 40px;
          // align-items: flex-start;
          // justify-content: flex-end;

          .hbr_text {
            width: fit-content;
            // max-width: 500px;
            background: #2992FF;
            border-radius: 10px 10px 10px 10px;
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 32px;
            box-sizing: border-box;
            padding: 10px;
          }

          .hbr_tx {
            width: 44px;
            height: 44px;
            margin-left: 20px;

          }
        }
      }
    }

    .o_bottom1 {
      width: 100%;
      background: #FFFFFF;
      box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.03);
      border-radius: 20px 20px 20px 20px;
      border: 1px solid #E9EBF2;
      box-sizing: border-box;
      padding: 20px;
      margin-bottom: 20px;
      position: relative;

      .ob_down {
        width: 30px;
        height: 30px;
        position: absolute;
        top: -60px;
        left: 50%;
        cursor: pointer;
        user-select: none;
        background-color: #fff;
        border-radius: 50%;
      }

      textarea {
        width: 100%;
        height: 56px;
        padding-bottom: 10px;
        border-bottom: 1px solid rgba(188, 188, 188, 0.2);
        font-size: 16px;
      }

      .ob_bottom1 {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;

        .obb_left {
          width: 90px;
          height: 30px;
          background: #F2F9FF;
          border-radius: 8px 8px 8px 8px;
          border: 1px solid #2992FF;
          font-weight: 500;
          font-size: 14px;
          color: #2992FF;
          text-align: center;
          line-height: 30px;
        }

        .obb_right {
          display: flex;
          align-items: center;

          .bbr_1 {
            width: 24px;
            height: 24px;
            margin-right: 30px;
            cursor: pointer;
          }

          .bbr_2 {
            width: 30px;
            height: 30px;
            cursor: pointer;

          }
        }
      }
    }
  }

  .one {
    width: 900px;
    margin-top: 150px;

    .o_top {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      div {
        font-weight: 400;
        font-size: 34px;
        color: #212121;
      }

      img {
        width: 86px;
        height: 110px;
      }
    }

    .o_bottom {
      width: 100%;
      // height: 246px;
      background: #FFFFFF;
      box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.03);
      border-radius: 20px 20px 20px 20px;
      border: 1px solid #E9EBF2;
      box-sizing: border-box;
      padding: 30px;

      textarea {
        width: 100%;
        height: 116px;
        padding-bottom: 20px;
        border-bottom: 1px solid rgba(188, 188, 188, 0.2);
        font-size: 16px;
      }

      .ob_bottom {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;

        .obb_left {
          width: 90px;
          height: 30px;
          background: #F2F9FF;
          border-radius: 8px 8px 8px 8px;
          border: 1px solid #2992FF;
          font-weight: 500;
          font-size: 14px;
          color: #2992FF;
          text-align: center;
          line-height: 30px;
        }

        .obb_right {
          display: flex;
          align-items: center;

          .bbr_1 {
            width: 24px;
            height: 24px;
            margin-right: 30px;
            cursor: pointer;
          }

          .bbr_2 {
            width: 30px;
            height: 30px;
            cursor: pointer;

          }
        }
      }
    }
  }
}

::v-deep {
  .el-carousel__arrow {
    display: none !important;
  }

  .el-carousel__container {
    height: 100% !important;
  }

  .el-carousel__item {
    display: flex;
    // align-items: center;
    flex-wrap: wrap;
    // align-content: space-around;
  }

  .el-carousel__button {
    width: 8px;
    height: 8px;
    background-color: #EAEAEA;
    border-radius: 4px;
  }

  .el-carousel__indicator.is-active button {
    background-color: #449DCF;
    width: 12px;
  }

  .el-carousel__indicators--outside {
    position: absolute;
    bottom: 0px;
    left: 335px;
  }

  .lb_center .el-carousel__indicators--outside {
    left: 680px;
    // right: 0;
  }

  .el-carousel__indicator--horizontal {
    padding: 0;
    margin: 0 4px;
  }

  .el-carousel__indicators--outside button {
    opacity: 1;
  }
}

.line1_ {
  word-break: break-all;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

// .r_list::-webkit-scrollbar {
//       display: none;
//     }

//     .r_list {
//       width: 100%;
//       height: 0;
//       flex: 1;
//       overflow-y: scroll;</style>
